export default {
  /* Main 頁面 */
  copyRight: 'Copyright',
  HomePage: '首页',
  ProductArea: '产品领域',
  BrandConcept: '品牌理念',
  DevelopmentProcess: '开发流程',
  TechnicalSupport: '技术支持',
  contactus: '联络我们',
  copy: '复制',
  // footer
  phone: '+886.2.2556.2973',
  email: 'contact@wandatech.com.tw',
  add: '台北市大同区重庆北路一段30号3楼',
  /* Index 頁面 */
  more: '了解更多',
  // 介紹萬達區
  readMore: '了解更多',
  aboutTitle1: '关于',
  aboutTitle2: '万达',
  aboutSubtitle: '愿景与使命',
  aboutContent: '万达资讯相信，通过持续的研究与开发，能够制造出能够与人类和谐共存，并在多种环境中提供帮助的机器人。万达的目标是使AI机器人不仅是高科技的代名词，更是可靠、安全、且具有社会责任感的同伴，并致力于打造一个更智慧、更连接、更好的未来。',
  cultureTitle: '文化与价值',
  cultureSubtitle1: '诚信',
  cultureSubtitle2: '团队合作',
  cultureSubtitle3: '永不停止的创新',
  cultureContent1: '诚信是万达资讯最核心的理念与价值。我们坚信以诚立业则无业不兴，以诚信的态度对待股东、客户、供货商及员工，并与他们建立互信、互知、互助的关系，并精诚合作发展互享互惠。',
  cultureContent2: '人才是企业最重要的资产，具备即战力的研发团队，就是成功打造服务的重要关键。万达资讯重视每一位伙伴的专业成长与自我挑战，培养出持续学习与成长的创新动能，并将沟通视为除了专业技能外最重要的工作能力，我们的团队由跨越多种领域的伙伴共同组成，为具有远大使命的企业客户，供应长期的研发技术能量。',
  cultureContent3: '"转型需与时俱进而创新要落实在组织内。 万达资讯面对新时代 重新定义指标 随时随地寻找问题 改变习惯 以「多元创新环境，提升竞争优势」理解内外部创新体质的重要性，经营全球, 放眼未来要有产品与技术实力，更需要敏锐的市场洞察力，方能永续。',
  // 開發過程區
  devMainTitle: '开发流程',
  devSubTitle1: '构思 & 设计',
  devSubTitle2: 'PoC & Prototype',
  devSubTitle3: '产品开发',
  devSubTitle4: '服务与规模',
  devSubContent1: '分析需求 藉专业的技术规划出最适合的解决方案',
  devSubContent2: '验证设计的开发概念 提高客户需求的可行性',
  devSubContent3: '特定專案小組 獨立工作團隊 提高靈活性及即時交件率',
  devSubContent4: '同开发团队进行维护及未来持续优化根据需求调整功能',
  // 技術支援區
  tectMainTitle: '技术支持',
  techIcon1: '技术支持',
  techIcon2: '教学指南',
  techIcon3: '用户权益',

  /* Trade 頁面 */
  platformTitle: '随时随地 多平台终端交易',
  platformSubTitle1: '覆盖iOS、Android、Windows、Mac多个平台，支持全业务功能。',
  platformSubTitle2: '',
  platIcon1: 'iOS, MAC',
  platIcon2: 'Android',
  platIcon3: 'Windows',
  platIcon4: '支持装置',

  /* Wallet 頁面 */
  scopeTitle: '技术范围',
  scopeSubtitle1: '加密蓝牙联机',
  scopeSubtitle2: 'EAL 认证安全组件',
  scopeSubtitle3: '交易功能支持多种加密货币',
  scopeContent1: '适用于 Android 及 iOS 的加密蓝牙联机，带来最便利的行动加密货币使用体验。',
  scopeContent2: '透过安全冷储存技术，安心一览投资组合与进行交易。',
  scopeContent3: '支持购买加密货币、Binance DEX、WalletConnect、代币间交换及多种强化功能，有助加快对 DeFi 通讯协议、NFT 收藏品、DApps、及其他新兴加密货币产品和服务的支持。',
  featureTitle: '产品特色',
  featureSubTitle1: '实时交换',
  featureSubTitle2: '简易创建和导入钱包',
  featureSubTitle3: '轻松管理多链资产',
  featureSubTitle4: '保护您资产的最先进技术',
  featureSubTitle5: '安全存储',
  featureContent1: '没有表格，没有自拍。随时轻松交易加密货币。',
  featureContent2: '用户友好的 UX 可帮助用户轻松查看和访问加密余额。',
  featureContent3: '同时支持20种钱包类型，BTC、ETH、HECO、DOGE、XRP、DOT、KSM、BCH、LTC、ETC、TRX、 XTZ、EOS、ATOM、BCH等。',
  featureContent4: '用户可以 100% 控制其安全存储在您设备上的私钥 。',
  featureContent5: '您的密钥受到 Secure Enclave、生物识别身份验证和可选的云备份的保护。'
  // 置底用
}
